import _regeneratorRuntime from "/var/jenkins_home/workspace/online-k8s-web-product-cloudv2@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/online-k8s-web-product-cloudv2@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-007d251c"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "contactUs"
};
var _hoisted_2 = {
  class: "contactUs-box"
};
var _hoisted_3 = {
  class: "contactUs-item-title"
};
var _hoisted_4 = {
  class: "contactUs-item-cont"
};
import Login from '@/api/pub';
import { $rdoLang } from '@/assets/common/common.js';
import { useLang } from '@/hooks/lang';
import { XlDialog } from '@shining3d/ui-components';
import { VueCookieNext } from 'vue-cookie-next';
export default {
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;
    var _useLang = useLang(),
      $t = _useLang.$t;
    var dialogVisible = ref(false);
    var contactLis = ref([]);
    var cookie = VueCookieNext;
    var lang = cookie.getCookie('lang');
    var local = $rdoLang(lang);
    var getInfoLoading = ref(false);
    var getInfo = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              getInfoLoading.value = true;
              _context.next = 3;
              return Login.getOiga(local, 'index').then(function (res) {
                console.log('getOiga: ' + res);
                contactLis.value = res.result;
                getInfoLoading.value = false;
              }).catch(function () {
                getInfoLoading.value = false;
              });
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getInfo() {
        return _ref2.apply(this, arguments);
      };
    }();
    expose({
      dialogVisible: dialogVisible,
      getInfo: getInfo
    });
    return function (_ctx, _cache) {
      var _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(XlDialog), {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return dialogVisible.value = $event;
        }),
        title: _unref($t)('home.contact'),
        width: "50%",
        modal: "",
        top: "0"
      }, {
        default: _withCtx(function () {
          return [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contactLis.value, function (contactLi, index) {
            return _openBlock(), _createElementBlock("div", {
              class: "contactUs-item",
              key: index
            }, [_createElementVNode("div", _hoisted_3, _toDisplayString(contactLi.field), 1), _createElementVNode("div", _hoisted_4, _toDisplayString(contactLi.content), 1)]);
          }), 128))])), [[_directive_loading, getInfoLoading.value]])];
        }),
        _: 1
      }, 8, ["modelValue", "title"])]);
    };
  }
};